import { useState } from "react";
import Header from "../header/Header";
import Settings from "../settings/Settings";
import * as SS from "../settings/styles";
import * as S from "./styles";

const LEVELS = [
  { key: "easy", label: "Easy" },
  { key: "medium", label: "Medium" },
  { key: "hard", label: "Hard" },
  { key: "expert", label: "Expert" },
];

const LevelScreen = ({ level, setLevel }) => {
  const [settingsOpen, setSettingsOpen] = useState(false);

  return (
    <S.Level>
      <Header />
      <SS.GearButton onClick={() => setSettingsOpen(true)} aria-label="settings">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
      </SS.GearButton>
      <S.LevelContent>
        <S.LevelTitle>select difficulty</S.LevelTitle>
        <S.LevelButtons>
          {LEVELS.map((l) => (
            <S.LevelButton
              key={l.key}
              className={level === l.key ? "active" : ""}
              onClick={() => setLevel(l.key)}
            >
              {l.label}
            </S.LevelButton>
          ))}
        </S.LevelButtons>
        <S.Hint>
          type falling words · <kbd>Esc</kbd> to clear · <kbd>Tab</kbd> to pause
        </S.Hint>
      </S.LevelContent>
      {settingsOpen ? <Settings onClose={() => setSettingsOpen(false)} /> : null}
    </S.Level>
  );
};

export default LevelScreen;
